export const getSupportUrl = (domain: string) => `https://${domain}.zendesk.com`;
